import { createFileRoute } from '@tanstack/react-router'
import CategorizationSection from 'Work/components/Work/Sections/Categorization/CategorizationSection'

export const Route = createFileRoute('/work/$workId/categorization')({
    component: CategorizationSection,
})
